import { CrudAbstractModel } from "../crud-abstract/crud-abstract.model";
export class Carrier extends CrudAbstractModel {
  constructor(
    public id: number,
    private name: string,
    private kind: string,
    private code: string | null = null,
  ) {
    super(id);
  }

  public getId(): number {
    return this.id;
  }

  public getName(): string {
    return this.name;
  }

  public getKind(): string {
    return this.kind;
  }

  public getCode(): string | null {
    return this.code;
  }

  public getRequestParams() {
    return {
      name: this.getName(),
      code: this.getCode(),
      kind: this.getKind(),
    };
  }
}
